import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgSmile = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 18,
	height: 18,
	viewBox: "0 0 18 18",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [
		/* @__PURE__ */ _jsx("path", {
			fillRule: "evenodd",
			clipRule: "evenodd",
			d: "M9 2.125C5.20304 2.125 2.125 5.20304 2.125 9C2.125 12.797 5.20304 15.875 9 15.875C12.797 15.875 15.875 12.797 15.875 9C15.875 5.20304 12.797 2.125 9 2.125ZM0.875 9C0.875 4.51269 4.51269 0.875 9 0.875C13.4873 0.875 17.125 4.51269 17.125 9C17.125 13.4873 13.4873 17.125 9 17.125C4.51269 17.125 0.875 13.4873 0.875 9Z",
			fill: "currentColor"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M6.1875 8.375C6.70527 8.375 7.125 7.95527 7.125 7.4375C7.125 6.91973 6.70527 6.5 6.1875 6.5C5.66973 6.5 5.25 6.91973 5.25 7.4375C5.25 7.95527 5.66973 8.375 6.1875 8.375Z",
			fill: "currentColor"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M11.8125 8.375C12.3303 8.375 12.75 7.95527 12.75 7.4375C12.75 6.91973 12.3303 6.5 11.8125 6.5C11.2947 6.5 10.875 6.91973 10.875 7.4375C10.875 7.95527 11.2947 8.375 11.8125 8.375Z",
			fill: "currentColor"
		}),
		/* @__PURE__ */ _jsx("path", {
			fillRule: "evenodd",
			clipRule: "evenodd",
			d: "M5.43623 10.3344C5.73476 10.1611 6.11724 10.2627 6.29052 10.5612C6.56597 11.0357 6.96122 11.4296 7.43672 11.7034C7.91222 11.9772 8.45129 12.1213 8.99998 12.1213C9.54867 12.1213 10.0877 11.9772 10.5632 11.7034C11.0387 11.4296 11.434 11.0357 11.7094 10.5612C11.8827 10.2627 12.2652 10.1611 12.5637 10.3344C12.8623 10.5077 12.9638 10.8902 12.7905 11.1887C12.4052 11.8526 11.8522 12.4036 11.187 12.7867C10.5218 13.1697 9.7676 13.3713 8.99998 13.3713C8.23236 13.3713 7.4782 13.1697 6.81297 12.7867C6.14775 12.4036 5.59479 11.8526 5.20944 11.1887C5.03616 10.8902 5.1377 10.5077 5.43623 10.3344Z",
			fill: "currentColor"
		})
	]
});
export default SvgSmile;
